import { ReportTypes } from 'modules/reports/models';
import { ApiRequest } from './network';
import { SparrowApi } from 'api/network/adapters/SparrowApi';
import { AnalyticsReportRequest, DownloadAllAudienceReport, DownloadAllReport } from 'modules/insights/models';
import moment from 'moment';
import { getCurrentTimeInUserTimezone } from 'utils/getCurrentTimeInUserTimezone';
import { TopicReportRequest } from 'modules/topics';

export class ReportsApi {
    constructor(private _sparrowApi: SparrowApi) {
    }

    public GetReportInfo = (reportId: string) => {
        return new ApiRequest(
            this._sparrowApi.TenantRequest()
                .get(`/{tenant}/adminapi/v1/reports/reportInfo/${reportId}`)
        );
    }

    public GetReportForDownload = (reportId: string) => {
        return new ApiRequest(
            this._sparrowApi.TenantRequest()
                .get(
                    `/{tenant}/adminapi/v1/reports/download/readReport/${reportId}`,
                    { responseType: 'arraybuffer'}
                )
        );
    }

    public SetReportDownloaded = (reportId: string) => {
        return new ApiRequest(
            this._sparrowApi.TenantRequest()
                .post(`/{tenant}/adminapi/v1/reports/markReportAsDownloaded/${reportId}`)
        );
    }

    public SendReportRequest = (report: Object) => {
        return new ApiRequest(
            this._sparrowApi.TenantRequest()
                .post(`/{tenant}/adminapi/v1/reports/addReportToQueue`, report)
        );
    }

    public SendUserReadReportRequest = (type: ReportTypes, contentId: string) => {
        let data = {
            type: type,
            contentId: contentId,
            dateRequested: moment().format("YYYY-MM-DD hh:mm A")
        };

        return this.SendReportRequest(data);
    }

    public SendTopicReportRequest = (payload: TopicReportRequest) => {
        return this.SendReportRequest(payload);
    }

    public SendAnalyticsReportRequest = (reportPayload: DownloadAllReport, reportType : string) => {
        let data = {
            type: ReportTypes.AnalyticsCsvReport,
            insights: reportPayload,
            category: reportType
        };

        return this.SendReportRequest(data);
    }

    public SendAllAnalyticsReportRequest = (reportPayload: DownloadAllReport, reportType: ReportTypes) => {
        const data = {
            type: reportType,
            insights: reportPayload,
        };

        return this.SendReportRequest(data);
    }

    public SendAudienceAnalyticsReportRequest = (reportPayload: DownloadAllAudienceReport, reportType: ReportTypes) => {
        const tz = getCurrentTimeInUserTimezone();
        const data: AnalyticsReportRequest = {
            type: reportType,
            audienceAnalyticsFilter: reportPayload,
            clientTimeOffset: tz.format('Z'),
            clientTimeZone: tz.format('z'),
            dateRequested: moment().format("YYYY-MM-DD hh:mm A"),
        };

        return this.SendReportRequest(data);
    }

    public SendSMSReportRequest = (type: ReportTypes) => {
        let data = this.GetReportRequest(type, undefined);

        return this.SendReportRequest(data);
    }

    public SendEmailActivityReportRequest = (emailId?: string) => {
        let data = this.GetReportRequest(ReportTypes.EmailActivityReport, emailId);

        return this.SendReportRequest(data);
    }

    public SendSMSActivityReportRequest = (smsId?: string) => {
        let data = this.GetReportRequest(ReportTypes.SMSActivityReport, smsId);

        return this.SendReportRequest(data);
    }

    public SendMobileUserDataReportRequest = () => {
        let data = this.GetReportRequest(ReportTypes.MobileUserDataReport);
        
        return this.SendReportRequest(data);
    }

    public GetReportRequest = (reportType: ReportTypes, contentId?: string) => {
        const tz = getCurrentTimeInUserTimezone();

        return {
            type: reportType,
            clientTimeZone: tz.format('z'),
            clientTimeOffset: tz.format('Z'),
            dateRequested: moment().format("YYYY-MM-DD hh:mm A"),
            contentId
        }
    }
}